import apiV1 from "../../services/apiV1";

export const register = (payload) =>
  apiV1.post("/auth/register", payload).then((r) => r.data.data);

export const login = (payload) =>
  apiV1.post("/auth/login", payload).then((r) => r.data.data);

export const me = () => apiV1.get("/auth/me").then((r) => r.data.data);

export const refresh = () =>
  apiV1.post("/auth/refresh").then((r) => r.data.data);

export const logout = () => apiV1.post("/auth/logout").then((r) => r.data);
